<template>
  <div>
    <div 
      v-if="loading"
      class="login-container loading_container d-flex justify-content-center align-items-center"
    >
      <div
        class="spinner-border text-primary"
        style="width: 5rem; height: 5rem"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <b-container class="d-flex justify-content-center flex-column" v-if="!loading">
      <b-container class="d-flex justify-content-center m-1">
        <span v-html="$t('ManageLoginComponent_AccountExternal.userdatasync_headline')" />
      </b-container>
      <b-alert show class="d-flex mb-4 mr-3 ml-3 flex-column">
        <div><span v-html="$t('ManageLoginComponent_AccountExternal.userdatasync_alertbox_title')"/></div>
        <div><span v-html="$t('ManageLoginComponent_AccountExternal.userdatasync_alertbox_description')" /></div>
      </b-alert>
      <b-container v-if="!isMobileViewPort" class="d-flex" style="column-gap: 20px;">
        <b-card 
          v-if="remoteUser"           
          class="cursor-pointer w-50"
          :class="{ selected: useLocaleData !== undefined && !useLocaleData }"
          @click="onDataSelect(false)"
        >
          <div class="d-flex justify-content-between">
            <label v-html="$t('ManageLoginComponent_AccountExternal.userdatasync_remote_user')" />
            <input type="radio" v-model="useLocaleData" name="syncData" value="false"/>
          </div>
          <div class="d-flex flex-column">
            <div class="d-flex" :key="propertyName" v-for="(value, propertyName) in remoteUserData">
              <div class="w-25">{{ propertyName }}</div> <div><strong>{{ value || '-' }}</strong></div>
            </div>
          </div>
        </b-card>
        <b-card 
          v-if="localUser"           
          class="cursor-pointer w-50"
          :class="{ selected: useLocaleData !== undefined && useLocaleData }"
          @click="onDataSelect(true)"
        >
          <div class="d-flex justify-content-between">
            <label v-html="$t('ManageLoginComponent_AccountExternal.userdatasync_local_user')" />
            <input type="radio" v-model="useLocaleData" name="syncData" value="true" />
          </div>
          <div class="d-flex flex-column">
            <div class="d-flex" :key="propertyName" v-for="(value, propertyName) in localUserData">
              <div class="w-25">{{ propertyName }}</div> <div><strong>{{ value || '-' }}</strong></div>
            </div>
          </div>
        </b-card>
      </b-container>
      <b-container v-if="isMobileViewPort" class="d-flex justify-content-between mb-2 flex-column">
        <b-container class="d-flex justify-content-center mt-3">
          <div>
            <CustomSwitch id="useLocaleDataSwitch" :value="useLocaleData" @change="onDataSelect">
              <template #labelBefore>{{ $t('ManageLoginComponent_AccountExternal.userdatasync_remote_user') }}</template>
              <template #labelAfter>{{ $t('ManageLoginComponent_AccountExternal.userdatasync_local_user') }}</template>
            </CustomSwitch>
          </div>
        </b-container>
        <b-card 
          v-if="remoteUser && !useLocaleData"           
          class="cursor-pointer"
        >
          <b-card-title v-html="$t('ManageLoginComponent_AccountExternal.userdatasync_remote_user')" />
          <b-card-body>
            <div :key="propertyName" v-for="(value, propertyName) in remoteUserData">
              {{ propertyName }}: {{ value }}
            </div>
          </b-card-body>
        </b-card>
        <b-card 
          v-if="localUser && useLocaleData"
          class="cursor-pointer"
        >
          <b-card-title v-html="$t('ManageLoginComponent_AccountExternal.userdatasync_local_user')" />
          <b-card-body>
            <div :key="propertyName" v-for="(value, propertyName) in localUserData">
              {{ propertyName }}: {{ value }}
            </div>
          </b-card-body>
        </b-card>
      </b-container>
      <b-container>
        <b-button                
          :disabled="useLocaleData === undefined || loading"
          class="login__box__login_btn terms"
          variant="primary"
          @click.prevent="syncUser()"
        >
          <template v-if="loading">
            <span class="login__box__loader" />
          </template>
          <template v-else>
            <span> Continue </span>
          </template>
        </b-button>
      </b-container>
    </b-container>
  </div>
</template>


<script>
import accountPageMixins from '../../mixins/accountPageMixins'
import CustomSwitch from '../../components/Switch.vue'

  export default {
    created() {
      window.addEventListener('resize', this.onResize)
    },
    destroyed() {
      window.removeEventListener('resize', this.onResize)
    },
      mixins: [
        accountPageMixins,
      ],
      async mounted() {
        this.loading = true
        const isUserComparisonNeeded = this.$store.getters['singleSignOn/ssoUserDataComparisonNeeded']
        if (isUserComparisonNeeded) {
          await this.loadExternalUserCompareData().then((res) => {
            this.localUser = res.localUser
            this.remoteUser = res.remoteUser
            this.fieldSetNames = res.fieldSetNames

            this.loading = false
          })   
        } else {
          this.syncUser(true)
        }
      },
      components: {
        CustomSwitch
      },
      props: ['ssoEvaluatedUserStatusAction'],
      data() {
        return {
          localUser: undefined,
          remoteUser: undefined,
          fieldSetNames: undefined,
          useLocaleData: false,
          AcceptTermsOfUse: false,
          loading: false,
          isMobileViewPort: window.innerWidth < 700          
        }
      },
      computed: {
        localUserData: function () {
          Object.keys(this.localUser).map((item) => {
            if(!this.fieldSetNames.includes(item)) { 
              delete this.localUser[item] 
            }
          })
          return this.localUser
        },
        remoteUserData: function () {
          Object.keys(this.remoteUser).map((item) => {
            if(!this.fieldSetNames.includes(item)) { 
              delete this.remoteUser[item] 
            }
          })
          return this.remoteUser
        }
      },
      methods: {
        onResize() {
          this.isMobileViewPort = window.innerWidth < 700
        }, 
        async syncUser(forceSync) {
          this.loading = true
          const needSync = forceSync ?? !this.useLocaleData
          await this.ssoSyncExternalUser(needSync).then((resStatus) => {
            if (resStatus === 200) {
              const redirectUrl = this.$store.getters['singleSignOn/ssoRedirectUrl']
              const token =  this.$store.getters['singleSignOn/ssoUserToken']
              //loginUser (used by normal login process) is doing the usual login process and with redirect automatically
              this.loginUser(token, false, redirectUrl)
            }
          })
        },   
        async onDataSelect(value) {
          console.log(value)
          this.useLocaleData = value
        }
      }     
  }

</script>

<style scoped>
  .login-container {
    display: flex;
    justify-content: center;
    min-height: 20vw;
  }
  .modal-text-scroll {
      max-height: 40vh;
      overflow-y: scroll;
  }

  .btn.terms {
      margin: 1rem auto;
  }

  .login__box__loader {
      width: 16px;
      height: 16px;
      border: 2px solid #FFF;
      border-bottom-color: transparent;
      border-radius: 50%;
      display: inline-block;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
  }

  @keyframes rotation {
      0% {
          transform: rotate(0deg);
      }
      100% {
          transform: rotate(360deg);
      }
  } 
  
  .login__box__login_btn:disabled {
    background-color: rgb(37, 37, 37);
    border-color: rgb(80, 80, 80);
    max-width: 200px;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .selected {
    background-color: rgba(142, 181, 245, 0.5);
  }

  .alertBox {
    background-color: #F3FBFF;
    border-radius: 4px;
    border: 1px solid #C5EEFE;
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;    
  }
</style>